module.exports = __webpack_public_path__ + "img/exercise_closed.cfc55a92.png";